import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { PERIOD_KINDS, PeriodKind } from '../../../@commons/@services/front/period-bars.util';

/** Légende des barres de période : chaque couleur porte son mot (R14). */
@Component({
  selector: 'vw-calendar-period-legend',
  imports: [TranslatePipe],
  changeDetection: ChangeDetectionStrategy.Eager,
  template: `
    <div class="flex flex-wrap items-center justify-center gap-x-3 gap-y-1">
      @for (kind of kinds; track kind) {
        <span class="inline-flex items-center gap-1.5 text-caption text-vw-body">
          <span class="period-legend__bar period__bar--{{ kind }} inline-block h-2.5 w-4 rounded-full" aria-hidden="true"></span>
          {{ 'calendar.legend.' + kind | translate }}
        </span>
      }
    </div>
  `,
})
export class CalendarPeriodLegendComponent {
  @Input() kinds: PeriodKind[] = PERIOD_KINDS;
}
